
/*
 * Filename: case-study-cards.js
 * By: J. Nguyen
 * Date: 7/1/21
 *
 * Description: 
 * This module will power the functionality for the case study cards.
 * These blocks will allow the user to click upon them to reveal a case study CTA or allow the user
 * to close the secondary card side and return to a standard image card side.
 *
 */


export default function CaseStudyCards(element) {

  const elem = element;                       // remember the DOM element that this object is bound to
  let api = {};                               // Object to contain the publicly accessible functions

  // default options
  const defaults = {
    debugMode: false
  };

  // DOM NODES
  const closeBtns = document.getElementsByClassName('js-close-card');
  const caseStudyCards = document.getElementsByClassName('js-case-study-cards');


  init();

  // initilize the module
  function init() {
    debug('insider CaseStudyCards init()');

    for ( let x=0; x < caseStudyCards.length; x++) {
      caseStudyCards[x].addEventListener("click", handleCardClick);
    }
    
    for ( let x=0; x < closeBtns.length; x++) {
      closeBtns[x].addEventListener("click", closeCurrentCard);
    }

  }


  // HELPER FUNCTIONS
  //===============================================
  
  // Basic debug function
  function debug(msg) { 
    if (defaults.debugMode) {
      console.log(msg);
    }
  }

  // PRIVATE FUNCTIONS
  //===============================================
  
  // close all cards
  function closeAllCards() {
    for ( let x=0; x < caseStudyCards.length; x++) {
      caseStudyCards[x].querySelector('.detail').classList.remove('active');
    }
  }

  
  // PUBLIC FUNCTIONS
  //===============================================
  
  // This function will activate a card
  function handleCardClick(event) {
    debug("inside handleCardClick()");  
    
    let cardDetail = this.querySelector('.detail');

    closeAllCards();

    if (cardDetail != null) {
      cardDetail.classList.add('active'); 
    }

    debug(event.target);
    debug(cardDetail);
  }
  
  // This function will close current active card
  function closeCurrentCard(event) {
    debug("inside closeCurrentCard()");  

    event.stopPropagation();
    event.target.parentNode.classList.remove('active');
  }
  
  // EXPOSE PUBLIC FUNCTIONS VIA THE API
  // Map all the functions we want to expose for public access
  //===============================================================
  api.handleCardClick = handleCardClick;
  api.closeCurrentCard = closeCurrentCard;
  return api;

}
